<template>
    <router-link :to="props.to">
        <a class="font-medium text-primary-color-600 hover:text-primary-color-500">
            <slot />
        </a>
    </router-link>
</template>

<script lang="ts" setup>
import { withDefaults } from "vue"

interface Props {
    to?: string
}

const props = withDefaults(defineProps<Props>(), {
    to: "/",
})
</script>
